<template lang="pug" src="./news-events.pug"></template>

<script>
import api from 'api'
import axios from 'axios'
import Loader from 'components/loader/loader'
import Gallery from 'components/custom/custom-news-gallery/custom-news-gallery'
import FooterMain from 'components/footer/footer'

export default {
  name: 'NewsEventsPage',
  data: () => {
    return {
      name: 'news-events',
      props: {},
      videosource: [],
      loading: true
    }
  },
  created () {
    this.loading = true
    axios.get(api + '/wp/v2/posts')
      .then(response => {
        this.props = response.data
        this.loading = false
      })
      .catch(e => {
        this.errors.push(e)
        console.log(e)
      })
    // this.content = this.$store.state.pages['news-events']
  },
  computed: {
    content () {
      return this.$store.state.pages['news-events']
    }
  },
  components: {
    Loader,
    FooterMain,
    Gallery
  }
}
</script>



// WEBPACK FOOTER //
// news-events.vue?01da76cf